{
  "salon-details-footer": {
    "text": {
      "contact-salon": "SALON CONTACT",
      "closed": "Closed",
      "opening-time": "OPENING TIME",
      "salon-location": "SALON LOCATION"
    }
  }
}
